import React from 'react';
import { StatCard } from './StatCard';
import { ContactsChart } from './ContactsChart';
import { UsersIcon, ContactsIcon, NewContactsIcon, MoneyIcon, EllipsisIcon } from './DashboardIcons';

const recentContacts = [
    { name: 'Carlos Sánchez', email: 'c.sanchez@example.com', type: 'Multa de Velocidad', date: 'Hace 2h' },
    { name: 'Ana García', email: 'ana.g@example.com', type: 'Informe Pericial', date: 'Hace 5h' },
    { name: 'John Doe', email: 'j.doe@example.com', type: 'Consulta General', date: 'Hace 1 día' },
    { name: 'Marie Dubois', email: 'm.dubois@example.com', type: 'Multa Aparcamiento', date: 'Hace 2 días' },
    { name: 'Luigi Rossi', email: 'l.rossi@example.com', type: 'Representación Judicial', date: 'Hace 3 días' },
];

export const DashboardOverview: React.FC = () => {
    return (
        <div>
            <h1 className="text-3xl font-bold text-gray-800 mb-2">Panel de Control</h1>
            <p className="text-gray-600 mb-8">Bienvenido de nuevo, Administrador.</p>
            
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
                <StatCard 
                    title="Total Contactos"
                    value="1,257"
                    icon={<ContactsIcon className="w-8 h-8"/>}
                    change="+12%"
                    changeColor="text-green-500"
                />
                <StatCard 
                    title="Nuevos (7 días)"
                    value="82"
                    icon={<NewContactsIcon className="w-8 h-8"/>}
                    change="+5.4%"
                    changeColor="text-green-500"
                />
                <StatCard 
                    title="Total Usuarios"
                    value="43"
                    icon={<UsersIcon className="w-8 h-8"/>}
                    change="+2"
                    changeColor="text-green-500"
                />
                 <StatCard 
                    title="Casos Activos"
                    value="115"
                    icon={<MoneyIcon className="w-8 h-8"/>}
                    change="-3"
                    changeColor="text-red-500"
                />
            </div>
            
            <div className="grid grid-cols-1 lg:grid-cols-5 gap-8">
                <div className="lg:col-span-3 bg-white p-6 rounded-lg shadow-sm">
                    <h2 className="text-xl font-semibold text-gray-800 mb-4">Actividad de Contactos (Últimos 7 días)</h2>
                    <div className="h-80">
                         <ContactsChart />
                    </div>
                </div>

                <div className="lg:col-span-2 bg-white p-6 rounded-lg shadow-sm">
                    <h2 className="text-xl font-semibold text-gray-800 mb-4">Consultas Recientes</h2>
                    <div className="space-y-4">
                        {recentContacts.map((contact, index) => (
                            <div key={index} className="flex items-center justify-between">
                                <div className="flex items-center">
                                    <div className="w-10 h-10 rounded-full bg-gray-200 flex items-center justify-center font-bold text-gray-600 mr-4">
                                        {contact.name.charAt(0)}
                                    </div>
                                    <div>
                                        <p className="font-semibold text-gray-800">{contact.name}</p>
                                        <p className="text-sm text-gray-500">{contact.type}</p>
                                    </div>
                                </div>
                                <div className="text-right">
                                    <p className="text-sm text-gray-500">{contact.date}</p>
                                    <button className="text-gray-400 hover:text-gray-600 mt-1">
                                        <EllipsisIcon />
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};